import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { login } from "../../stores";
import { Button, Form } from "react-bootstrap";
import SignIn from "assets/img/sign_in_illustration_2.svg";
import LogoPugar from "assets/img/pugar.png";

function LoginPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPass, setShowPass] = React.useState(false);

  const submit = (event) => {
    event.preventDefault();
    login(dispatch, { email, password }, history);
  };

  return (
    <div className="admin-login-shell">
      <section className="admin-login-visual">
        <div className="admin-login-brand">
          <img src={LogoPugar} alt="PUGAR" />
          <div>
            <strong>PUGAR</strong>
            <span>Admin Portal</span>
          </div>
        </div>
        <div className="admin-login-copy">
          <span>Dashboard koperasi</span>
          <h1>Kelola data PUGAR dengan lebih rapi.</h1>
          <p>
            Akses khusus super admin, admin, HRD, dan payroll untuk monitoring
            anggota, simpanan, pengajuan, serta pelunasan.
          </p>
        </div>
        <img className="admin-login-art" src={SignIn} alt="Admin dashboard" />
      </section>

      <section className="admin-login-panel">
        <div className="admin-login-card">
          <div className="admin-login-card-header">
            <span>Masuk admin</span>
            <h2>Selamat datang</h2>
            <p>Gunakan akun admin yang sudah terdaftar.</p>
          </div>

          <Form onSubmit={submit} className="admin-login-form">
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <div className="admin-login-input">
                <i className="fas fa-envelope" />
                <Form.Control
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="nama@email.com"
                  type="email"
                  autoComplete="email"
                />
              </div>
            </Form.Group>

            <Form.Group>
              <Form.Label>Password</Form.Label>
              <div className="admin-login-input">
                <i className="fas fa-lock" />
                <Form.Control
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Masukkan password"
                  type={showPass ? "text" : "password"}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="admin-login-eye"
                  onClick={() => setShowPass(!showPass)}
                  aria-label={showPass ? "Sembunyikan password" : "Lihat password"}
                >
                  <i className={showPass ? "fas fa-eye" : "fas fa-eye-slash"} />
                </button>
              </div>
            </Form.Group>

            <Button className="admin-login-submit" type="submit">
              Masuk Admin
            </Button>

            <Button
              className="admin-login-member"
              type="button"
              onClick={() => history.push("/member/auth/login")}
            >
              Masuk User/Karyawan
            </Button>
          </Form>

          <div className="admin-login-links">
            <a href="/auth/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            <a
              href="/auth/termsandconditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}

export default LoginPage;
